import React from "react";
var UnderstandingSectionIcon = function () {
    return (React.createElement("div", { className: "rounded-circle understanding-icon d-flex align-items-center justify-content-center" },
        React.createElement("i", { className: "edel-icon-info" })));
};
export default UnderstandingSectionIcon;
